import { SidebarItem } from './components';

import { SidebarHelper } from './lib';

import { classes } from './Sidebar.tailwind';

const Sidebar = () => {
  const sections = SidebarHelper.getSections();

  return (
    <div className={classes.wrapper}>
      <ul className={classes.list}>
        {sections.map(section => (
          <SidebarItem key={section.title} {...section} />
        ))}
      </ul>
    </div>
  );
};

export default Sidebar;
